module.exports = __webpack_public_path__ + "static/img/album5_202501_02.fcd4fc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album5_202501_02.jpg
// module id = cEpU
// module chunks = 99